// Badges SOFT do lifecycle de versão (§4.5): DRAFT (âmbar),
// PUBLISHED (esmeralda), ARCHIVED (cinza) + chip "Ativa".
import type { TFunction } from "i18next"

import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils"
import type { NotificationTemplateVersionStatusType } from "@/types/notification-center"

const STATUS_CLASSES: Record<
  NotificationTemplateVersionStatusType,
  string
> = {
  DRAFT: "border-amber-200 bg-amber-50 text-amber-700",
  PUBLISHED:
    "border-emerald-200 bg-emerald-50 text-emerald-700",
  ARCHIVED: "border-slate-200 bg-slate-50 text-slate-600",
}

export const getVersionStatusLabel = (
  t: TFunction,
  status: NotificationTemplateVersionStatusType
) =>
  t(
    `pages.notificationCenter.templateEditorPage.versions.status.${status}`
  )

export const TemplateVersionStatusBadge = ({
  status,
  label,
}: {
  status: NotificationTemplateVersionStatusType
  label: string
}) => (
  <Badge
    variant="outline"
    className={cn(
      "rounded-full border font-medium",
      STATUS_CLASSES[status]
    )}
  >
    {label}
  </Badge>
)

// Chip "Ativa" — sempre ao lado da ÚNICA versão ativa.
export const TemplateActiveVersionBadge = ({
  label,
}: {
  label: string
}) => (
  <Badge
    variant="outline"
    className="rounded-full border border-sky-200 bg-sky-50 font-medium text-sky-700"
  >
    {label}
  </Badge>
)
